import { apiDomain as api, apiKey } from '../appConfig';

const getBRNHCD = async (data) =>
	fetch(`${api}/SCWS/Service.asmx/GETBRNHCD`, {
		method: 'POST',
		body: data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'Ocp-Apim-Subscription-Key': apiKey,
		},
	})
		.then((res) => res.json())
		.catch((err) => console.error(err));

export default getBRNHCD;



// WEBPACK FOOTER //
// ./src/js/fetch/getBRNHCD.js